/* eslint-disable no-param-reassign */
import produce from 'immer';
import { ActionType } from './countries.types';

const initialState = {
  countries: [],
  timezones: [],
  easternEuropeCountries: [],
};

export const countriesReducer = (state = initialState, action = '') => {
  return produce(state, (draftState) => {
    if (action.type === ActionType.GET_COUNTRIES) {
      draftState.countries = action.payload.map((country) => ({
        id: country.id,
        value: country.id,
        label: `${country.name} (${country.code})`,
        currency: country.currency,
        currencyLabel: `${country.name} (${country.currency})`,
        rate: country.rate,
        code: country.code,
        numericIsoCode: country.numericIsoCode,
      }));
    }

    if (action.type === ActionType.TIMEZONE_LIST) {
      draftState.timezones = action.payload.results;
    }

    if (action.type === ActionType.GET_EASTERN_EUROPE_COUNTRIES) {
      draftState.easternEuropeCountries = action.payload;
    }
  });
};
